import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-void-item-message',
  templateUrl: './void-item-message.component.html',
  styleUrls: ['./void-item-message.component.scss']
})
export class VoidItemMessageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
